import React from 'react';
import Card from '../Card/Card';
import { Button } from 'reactstrap'

const CardBlock = ({...props}) => {
    let list = [];
    if(props.list !== undefined){
        list = props.list        
    }

    const renderCards = () => (
        list ?
        list.map((card,index) => (
                <Card key={index} {...card} />
        )) : null
    )
    return (
        <>
        <div className="container" style={{ marginTop:"3%" }}>
            <div className='row'>
                <div className="col">
                    <div style={{display:'flex',flexWrap:'wrap'}}>
                        {renderCards(props.list)}
                    </div>
                </div>            
            </div>
            {
                props.totalPages > props.page ? 
                <div className="row" style={{ marginTop:"3%", marginBottom:"3%" }}>
                    <div className="col text-center">
                        <Button className="btn btn-md btn-default btn-round o" onClick={() => props.loadMore()} style={{ display:props.display }}>Xem thêm <i class="fas fa-caret-down" aria-hidden="true"></i></Button>
                    </div>
                </div> 
                : null
            }
        </div>
        </>
    )
};

export default CardBlock;